import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Returns_ds_find_lotsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { id?: number, lookupcode?: string, materialId?: number, statusId?: number, typeId?: number, vendorlotId?: number, materialCode?: string, vendorLotCode?: string, projectId?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MaterialId?: number, StatusId?: number, TypeId?: number, VendorLotId?: number, VendorLot?: { ExpirationDate?: string, LookupCode?: string }, Status?: { Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/Returns/datasources/ds_find_lots/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { id?: number, lookupcode?: string, materialId?: number, statusId?: number, typeId?: number, vendorlotId?: number, materialCode?: string, vendorLotCode?: string, projectId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MaterialId?: number, StatusId?: number, TypeId?: number, VendorLotId?: number, VendorLot?: { ExpirationDate?: string, LookupCode?: string }, Status?: { Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Returns/datasources/ds_find_lots/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { id?: number, lookupcode?: string, materialId?: number, statusId?: number, typeId?: number, vendorlotId?: number, materialCode?: string, vendorLotCode?: string, projectId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MaterialId?: number, StatusId?: number, TypeId?: number, VendorLotId?: number, VendorLot?: { ExpirationDate?: string, LookupCode?: string }, Status?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_find_lots/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      id?: number, lookupcode?: string, materialId?: number, statusId?: number, typeId?: number, vendorlotId?: number, materialCode?: string, vendorLotCode?: string, projectId?: number    }) {
      return false;
    }
}
